import { createRouter, createWebHistory } from 'vue-router';

export const router = createRouter({
  history: createWebHistory(),
  routes: [
    { path: '/', name: 'overview', component: () => import('./pages/Overview.vue') },
    { path: '/login', name: 'login', component: () => import('./pages/Login.vue') },
    {
      path: '/clients',
      name: 'clients',
      component: () => import('./pages/Stub.vue'),
      props: { section: 'Clients' },
    },
    {
      path: '/restaurant',
      name: 'restaurant',
      component: () => import('./pages/Stub.vue'),
      props: { section: 'Restaurant' },
    },
    {
      path: '/pcs',
      name: 'pcs',
      component: () => import('./pages/Stub.vue'),
      props: { section: 'PCs' },
    },
    {
      path: '/store',
      name: 'store',
      component: () => import('./pages/Stub.vue'),
      props: { section: 'Store' },
    },
    {
      path: '/config',
      name: 'config',
      component: () => import('./pages/Stub.vue'),
      props: { section: 'Config' },
    },
    {
      path: '/showcase',
      component: () => import('./pages/ShowcaseLayout.vue'),
      children: [
        { path: '', redirect: '/showcase/calibration' },
        { path: 'calibration', component: () => import('./pages/showcase/Calibration.vue') },
        { path: 'typography',  component: () => import('./pages/showcase/Typography.vue') },
        { path: 'buttons',     component: () => import('./pages/showcase/Buttons.vue') },
        { path: 'forms',       component: () => import('./pages/showcase/Forms.vue') },
        { path: 'feedback',    component: () => import('./pages/showcase/Feedback.vue') },
        { path: 'data',        component: () => import('./pages/showcase/Data.vue') },
        { path: 'media',       component: () => import('./pages/showcase/Media.vue') },
      ],
    },
    { path: '/:pathMatch(.*)*', redirect: '/' },
  ],
});
